import React from 'react';
import Icon from '../Icon';
import { ITemporaryAnnouncement } from '../../../interfaces/temporaryAnnouncements';
import { Wrapper } from './TemporaryAnnouncement.styles';

type Props = {
  announcement: ITemporaryAnnouncement;
  onClose: () => void;
  onOpenCTA?: () => void;
};

const TemporaryAnnouncement: React.FC<Props> = ({ announcement, onClose, onOpenCTA }) => {
  return (
    <Wrapper>
      <div className='temporary-announcement'>
        <div className='temporary-announcement-icon'>
          <Icon name='alert' />
        </div>
        <div className='temporary-announcement-wrapper'>
          <h3 className='temporary-announcement-message'>{announcement.message}</h3>
          {announcement.cta && (
            <button type='button' className='temporary-announcement-cta' onClick={onOpenCTA}>
              <span>{announcement.cta.label}</span>
              <svg width='12' height='12' viewBox='0 0 12 12' fill='none' xmlns='http://www.w3.org/2000/svg'>
                <path
                  fillRule='evenodd'
                  clipRule='evenodd'
                  d='M3.24982 0.994713C3.25274 0.58051 3.59089 0.247099 4.00509 0.250019L10.9551 0.299019C11.3651 0.30191 11.6968 0.633568 11.6998 1.04361L11.7498 7.99461C11.7528 8.40881 11.4194 8.747 11.0052 8.74998C10.591 8.75296 10.2528 8.4196 10.2498 8.0054L10.2127 2.84774L1.58013 11.4803C1.28724 11.7732 0.812368 11.7732 0.519475 11.4803C0.226581 11.1874 0.226581 10.7126 0.519475 10.4197L9.1528 1.78635L3.99452 1.74998C3.58031 1.74706 3.2469 1.40892 3.24982 0.994713Z'
                  fill='#744210'
                  fillOpacity='1'
                />
              </svg>
            </button>
          )}
        </div>
        <button type='button' className='temporary-announcement-close-button' onClick={onClose} aria-label='Fechar aviso'>
          <svg data-testid='close#' viewBox='0 0 24 24' height='24' width='24'><path fillRule='evenodd'
            d='M7.46967 7.46967C7.76256 7.17678 8.23744 7.17678 8.53033 7.46967L12 10.9393L15.4697 7.46967C15.7626 7.17678 16.2374 7.17678 16.5303 7.46967C16.8232 7.76256 16.8232 8.23744 16.5303 8.53033L13.0607 12L16.5303 15.4697C16.8232 15.7626 16.8232 16.2374 16.5303 16.5303C16.2374 16.8232 15.7626 16.8232 15.4697 16.8232L12 13.0607L8.53033 16.5303C8.23744 16.8232 7.76256 16.8232 7.46967 16.5303C7.17678 16.2374 7.17678 15.7626 7.46967 15.4697L10.9393 12L7.46967 8.53033C7.17678 8.23744 7.17678 7.76256 7.46967 7.46967Z' /></svg>
        </button>
      </div>
    </Wrapper>
  );
};

export default TemporaryAnnouncement;

